module.exports = __webpack_public_path__ + "img/1009_pc.6240889b.gif";